// extracted by mini-css-extract-plugin
export default {"waikawaGray":"#666","black":"#000"};